module.exports = __webpack_public_path__ + "assets/pebbles-white.ad7ffe71.svg";